import { TableContainer, TableCell, TableRow, Chip } from '@mui/material';
import { styled } from '@mui/system';

/** Soft-table look from html-preview/xtram_dashboard (.soft-table). */
const softBorder = '#e5ebf3';
const softHeaderBorder = '#e5ebf3';
const softHeaderBg = '#fbfcfe';
const softText = '#18365f';
const softHeaderText = '#1d3c6a';

export const PanelTableContainer = styled(TableContainer)({
    borderRadius: 10,
    border: `1px solid ${softBorder}`,
    boxShadow: 'none',
    overflow: 'hidden',
    marginTop: 0,
    background: '#fff',
});

const headCellBase = {
    background: softHeaderBg,
    color: softHeaderText,
    fontWeight: 700,
    textAlign: 'center',
    borderTop: 'none',
    borderBottom: `1px solid ${softHeaderBorder}`,
    borderLeft: `1px solid ${softBorder}`,
    borderRight: 'none',
    minWidth: 72,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    lineHeight: 1.25,
    padding: '10px 12px',
    fontSize: 'var(--xtram-panel-head, 11px)',
    letterSpacing: '0.01em',
    textTransform: 'none',
    height: 'var(--xtram-panel-head-height, 34px)',
    boxSizing: 'border-box',
    '&:last-of-type': {
        borderLeft: 'none',
    },
};

export const PanelHeadCell = styled(TableCell)(headCellBase);

export const VatPanelHeadCell = styled(TableCell)(headCellBase);

export const PanelBodyRow = styled(TableRow)({
    backgroundColor: '#fff',
    transition: 'background-color 0.15s ease',
    '&:hover': {
        backgroundColor: '#f8fafc',
    },
    '& .MuiTableCell-root': {
        borderBottom: `1px solid ${softBorder}`,
        borderLeft: `1px solid ${softBorder}`,
        borderRight: 'none',
        borderTop: 'none',
        textAlign: 'center',
        color: softText,
        fontSize: 'var(--xtram-panel-cell, 12px)',
        fontWeight: 500,
        padding: '8px 10px',
        lineHeight: 1.35,
        backgroundColor: 'transparent',
        boxSizing: 'border-box',
        '&:last-of-type': {
            borderLeft: 'none',
        },
    },
    '&:last-of-type .MuiTableCell-root': {
        borderBottom: 'none',
    },
});

export const PanelNumberCell = styled(TableCell)({
    textAlign: 'center',
    fontVariantNumeric: 'tabular-nums',
    fontWeight: 500,
    fontSize: 'var(--xtram-panel-cell, 12px)',
    color: softText,
    padding: '8px 10px',
    lineHeight: 1.35,
    whiteSpace: 'nowrap',
});

/** Soft total row (dashboard .soft-table tr.total). */
export const PanelTotalRow = styled(TableRow)({
    '& .MuiTableCell-root': {
        background: softHeaderBg,
        color: '#185eea',
        fontWeight: 800,
        borderBottom: 'none',
        borderLeft: `1px solid ${softBorder}`,
        textAlign: 'center',
        fontSize: 'var(--xtram-panel-cell, 12px)',
        padding: '8px 10px',
        '&:last-of-type': {
            borderLeft: 'none',
        },
    },
});

export const PanelStatusBadge = styled(Chip)(({ palette = 'default' }) => ({
    fontSize: 'var(--xtram-panel-badge, 10px)',
    height: 'var(--xtram-grid-pill-height, 24px)',
    borderRadius: 999,
    fontWeight: 700,
    letterSpacing: '0.01em',
    border: '1px solid transparent',
    minWidth: 60,
    ...(palette === 'computed' && {
        background: '#eaf8f0',
        color: '#13955d',
        borderColor: '#bfedd5',
    }),
    ...(palette === 'reported' && {
        background: '#fff6e8',
        color: '#d97706',
        borderColor: '#ffe0a7',
    }),
    ...(palette === 'difference' && {
        background: '#eef4ff',
        color: '#2961db',
        borderColor: '#cad9ff',
    }),
}));

/** Shared MUI Table sx for VAT / Advances soft tables. */
export const softPanelTableSx = {
    width: '100%',
    minWidth: 400,
    borderCollapse: 'collapse',
    '& .MuiTableCell-root': {
        borderColor: softBorder,
    },
    '& .MuiTableHead-root .MuiTableCell-root': {
        background: softHeaderBg,
        color: softHeaderText,
        fontWeight: 700,
        fontSize: 'var(--xtram-panel-cell, 12px)',
        borderBottom: `1px solid ${softHeaderBorder} !important`,
        borderLeft: `1px solid ${softBorder} !important`,
        '&:last-of-type': {
            borderLeft: 'none !important',
        },
    },
};
